/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown>, amount: NonNullable<unknown> }} Gateway_Spending_Cap_Threshold_InfoInputs */



/**
* | output |
* | --- |
* | "Warning email at {pct}% (€{amount})" |
*
* @param {Gateway_Spending_Cap_Threshold_InfoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_spending_cap_threshold_info = /** @type {((inputs: Gateway_Spending_Cap_Threshold_InfoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Spending_Cap_Threshold_InfoInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Warnung per E-Mail bei ${i?.pct}% (€${i?.amount})`)
	return /** @type {LocalizedString} */ (`Warning email at ${i?.pct}% (€${i?.amount})`)
});